/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createDestinationItemCategory } from "../graphql/mutations";
const client = generateClient();
export default function DestinationItemCategoryCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    destinationId: "",
    destinationItemId: "",
    title: "",
    isActive: false,
  };
  const [destinationId, setDestinationId] = React.useState(
    initialValues.destinationId
  );
  const [destinationItemId, setDestinationItemId] = React.useState(
    initialValues.destinationItemId
  );
  const [title, setTitle] = React.useState(initialValues.title);
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setDestinationId(initialValues.destinationId);
    setDestinationItemId(initialValues.destinationItemId);
    setTitle(initialValues.title);
    setIsActive(initialValues.isActive);
    setErrors({});
  };
  const validations = {
    destinationId: [],
    destinationItemId: [],
    title: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          destinationId,
          destinationItemId,
          title,
          isActive,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createDestinationItemCategory.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "DestinationItemCategoryCreateForm")}
      {...rest}
    >
      <TextField
        label="Destination id"
        isRequired={false}
        isReadOnly={false}
        value={destinationId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId: value,
              destinationItemId,
              title,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.destinationId ?? value;
          }
          if (errors.destinationId?.hasError) {
            runValidationTasks("destinationId", value);
          }
          setDestinationId(value);
        }}
        onBlur={() => runValidationTasks("destinationId", destinationId)}
        errorMessage={errors.destinationId?.errorMessage}
        hasError={errors.destinationId?.hasError}
        {...getOverrideProps(overrides, "destinationId")}
      ></TextField>
      <TextField
        label="Destination item id"
        isRequired={false}
        isReadOnly={false}
        value={destinationItemId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              destinationItemId: value,
              title,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.destinationItemId ?? value;
          }
          if (errors.destinationItemId?.hasError) {
            runValidationTasks("destinationItemId", value);
          }
          setDestinationItemId(value);
        }}
        onBlur={() =>
          runValidationTasks("destinationItemId", destinationItemId)
        }
        errorMessage={errors.destinationItemId?.errorMessage}
        hasError={errors.destinationItemId?.hasError}
        {...getOverrideProps(overrides, "destinationItemId")}
      ></TextField>
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              destinationItemId,
              title: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              destinationId,
              destinationItemId,
              title,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
